import {
  isViewportLiteral,
  Viewport,
  type ViewportLiteral,
} from "../pixel-accessor";
import type { OutputViewportStrategy } from "./OutputViewportStrategy";
import type { ReversePixelMapper } from "../pixel-mapper";
import type { ImageAdapter } from "../image-adapter";

/**
 * Uses user-provided viewport as output image viewport.
 * Have highest priority.
 * Matches if user provided output viewport via option.
 */
export class UserProvidedViewport implements OutputViewportStrategy {
  /**
   * @inheritDoc
   */
  readonly priority = 1;

  /**
   * @inheritDoc
   */
  match(
    reversePixelMapper: ReversePixelMapper,
    viewport: "bestFit" | boolean | ViewportLiteral
  ): boolean {
    return isViewportLiteral(viewport);
  }

  /**
   * @inheritDoc
   */
  getOutputViewport(
    image: ImageAdapter<unknown>,
    reversePixelMapper: ReversePixelMapper,
    viewport: "bestFit" | boolean | ViewportLiteral
  ): Viewport {
    if (isViewportLiteral(viewport)) {
      return Viewport.fromLiteral(viewport);
    }
    throw new TypeError("'viewport argument should be ViewportLiteral");
  }
}
